const interests = [
  { key: "chat", name: "Chat" },
  { key: "date", name: "Date" },
  { key: "flirt", name: "Flirt" },
  { key: "sexyTalk", name: "Sexy Talk" },
];

export default interests;
